import type { ApiDataResponse, ApiIncomeCalculatorConfig } from '@app/packages/internalApi/types'
import { createInternalApiAction, encode } from '@app/packages/internalApi/utils'

export const getIncomeCalculatorConfigsBySlug = (slug: string) =>
  createInternalApiAction('getIncomeCalculatorConfigsBySlug', dispatch =>
    dispatch<ApiDataResponse<ApiIncomeCalculatorConfig>>({
      method: 'GET',
      endpoint: encode`/internal/api/v1/income_calculator_configs/by_slug/${slug}`,
    })
  )
